import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import cx from 'classnames';
import s from './ColorSample.scss';
import { keyboardEvents } from '../../../constants';
export class ColorSample extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "ref", void 0);
    _defineProperty(this, "onMouseEnter", description => {
      if (this.isActive() && this.props.onMouseEnter) {
        this.props.onMouseEnter(description);
      }
    });
    _defineProperty(this, "onMouseLeave", e => {
      if (this.isActive() && this.props.onMouseLeave) {
        this.props.onMouseLeave(e);
      }
    });
    _defineProperty(this, "onChange", e => {
      if (this.isActive() && this.props.onChange) {
        var _this$props$onFocus, _this$props;
        (_this$props$onFocus = (_this$props = this.props).onFocus) == null || _this$props$onFocus.call(_this$props, e);
        this.props.onChange(e);
      }
    });
    _defineProperty(this, "onKeyDown", e => {
      const increase = [keyboardEvents.ARROW_RIGHT, keyboardEvents.ARROW_UP].map(_ => _.keyCode);
      const decrease = [keyboardEvents.ARROW_LEFT, keyboardEvents.ARROW_DOWN].map(_ => _.keyCode);
      const keyCode = e.charCode || e.keyCode;
      if (keyCode === keyboardEvents.ENTER.keyCode) {
        return this.onChange(e);
      }
      if (keyCode === keyboardEvents.TAB.keyCode) {
        return this.props.onKeyboardTabEvent && this.props.onKeyboardTabEvent();
      }
      if (!this.props.onKeyboardArrowEvent) {
        /* istanbul ignore next */
        return;
      }
      if (increase.includes(keyCode)) {
        this.props.onKeyboardArrowEvent(1);
      }
      if (decrease.includes(keyCode)) {
        this.props.onKeyboardArrowEvent(-1);
      }
    });
    _defineProperty(this, "focus", () => {
      this.ref.current.focus();
    });
    _defineProperty(this, "isActive", () => {
      return !this.props.isDisabled;
    });
    this.ref = /*#__PURE__*/React.createRef();
  }
  componentDidUpdate(prevProps) {
    if (this.props.isFocused && !prevProps.isFocused) {
      this.props.shouldFocus && this.focus();
    }
  }
  render() {
    const {
      description,
      isSelected,
      isDisabled,
      rgbColorValue,
      colorSampleClassName,
      allowMultiple,
      isFocused
    } = this.props;
    const focusRingOnSiblingClassName = 'wixSdkShowFocusOnSibling';
    const classNames = cx(s.colorSample, focusRingOnSiblingClassName, {
      [s.disabled]: !this.isActive()
    }, colorSampleClassName);
    return /*#__PURE__*/React.createElement("label", {
      onMouseEnter: () => this.onMouseEnter(description),
      onMouseLeave: this.onMouseLeave,
      onFocus: () => this.onMouseEnter(description),
      onBlur: e => this.onMouseLeave(e),
      className: s.label,
      "data-hook": "color-sample"
    },
    /*#__PURE__*/
    //eslint-disable-next-line jsx-a11y/role-supports-aria-props
    React.createElement("input", {
      "aria-label": description,
      "aria-checked": isSelected,
      checked: isSelected,
      tabIndex: isFocused ? 0 : -1,
      className: s.input,
      disabled: isDisabled,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      ref: this.ref,
      type: allowMultiple ? 'checkbox' : 'radio'
    }), /*#__PURE__*/React.createElement("span", {
      style: {
        backgroundColor: rgbColorValue
      },
      className: classNames
    }));
  }
}
//# sourceMappingURL=ColorSample.js.map